import 'css-chunk:src/app/containers/Home/ClientsView/ClientListView.scss';export default {
  "ClientListView": "_ClientListView_11402_2",
  "header": "_header_11402_2",
  "createButton": "_createButton_11402_7",
  "table": "_table_11402_10",
  "nameCell": "_nameCell_11402_10"
};